import type {
  Attributes,
  ExceptionContext,
  LoggerProvider,
  Span,
  SpanOptions,
} from '../types';

/**
 * Abstract base class for logger providers
 * Provides default no-op implementations
 */
export abstract class BaseLoggerProvider implements LoggerProvider {
  abstract trace(message: string, attributes?: Attributes): void;
  abstract debug(message: string, attributes?: Attributes): void;
  abstract info(message: string, attributes?: Attributes): void;
  abstract warn(message: string, attributes?: Attributes): void;
  abstract error(message: string, attributes?: Attributes): void;
  abstract fatal(message: string, attributes?: Attributes): void;

  abstract startSpan<T>(
    name: string,
    options: SpanOptions,
    callback: (span: Span) => Promise<T>
  ): Promise<T>;

  abstract captureException(error: Error, context?: ExceptionContext): void;

  /**
   * Helper to format log messages with attributes
   */
  protected formatLog(message: string, attributes?: Attributes): string {
    if (!attributes || Object.keys(attributes).length === 0) {
      return message;
    }
    return `${message} ${JSON.stringify(attributes)}`;
  }
}
